document.addEventListener("DOMContentLoaded", function () {
  const hashLinks = document.querySelectorAll('a[href="#"]');

  hashLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector('form[action*="account"]');
  const password = document.getElementById("RegisterForm-password");
  const confirmPassword = document.getElementById(
    "RegisterForm-password-confirmation",
  );
  const errorDiv = document.getElementById("password-error");
  const submitButton = document.getElementById("register-button");

  // Stop execution if required elements are missing
  if (!form || !password || !confirmPassword || !submitButton) return;

  function validatePasswords() {
    if (password.value === "" || confirmPassword.value === "") {
      if (errorDiv) errorDiv.style.display = "none";
      confirmPassword.setCustomValidity("");
      submitButton.disabled = false;
      return true;
    }

    if (password.value !== confirmPassword.value) {
      if (errorDiv) errorDiv.style.display = "block";
      confirmPassword.setCustomValidity("Passwords do not match");
      submitButton.disabled = true;
      return false;
    }

    if (errorDiv) errorDiv.style.display = "none";
    confirmPassword.setCustomValidity("");
    submitButton.disabled = false;
    return true;
  }

  form.addEventListener("submit", function (e) {
    if (!validatePasswords()) {
      e.preventDefault();
    }
  });

  confirmPassword.addEventListener("input", validatePasswords);

  password.addEventListener("input", function () {
    if (confirmPassword.value) validatePasswords();
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const announcement = document.querySelector(".announcement-bar-section");
  const header = document.querySelector(".header-wrapper");
  if (header instanceof HTMLElement) {
    const headerHeight = header.offsetHeight;
    document.body.style.setProperty("--header-height", `${headerHeight}px`);
  }
  //combined height (announcement + header)
  if (announcement instanceof HTMLElement && header instanceof HTMLElement) {
    const totalHeight = announcement.offsetHeight + header.offsetHeight;
    document.body.style.setProperty(
      "--announcement-header-height",
      `${totalHeight}px`,
    );
  }
});

// menu hover open
document.querySelectorAll("header-menu details").forEach((details) => {
  details.addEventListener("mouseenter", () => {
    details.setAttribute("open", "");
    document.body.classList.add("megamenu-open", "overflow-hidden");
  });

  details.addEventListener("mouseleave", () => {
    details.removeAttribute("open");
    document.body.classList.remove("megamenu-open", "overflow-hidden");
  });
});

const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType === 1) {
        const newHashLinks = node.querySelectorAll
          ? node.querySelectorAll('a[href="#"]')
          : [];
        newHashLinks.forEach(function (link) {
          link.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
          });
        });
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

//FAQ
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ctm_multifaq_title_main").forEach((section) => {
    const questions = section.querySelectorAll(".faq_question");
    let previousActiveQuestion = null;

    questions.forEach((question, index) => {
      const icon = question.querySelector(".icon-shape");
      const answer = question.nextElementSibling;

      // Toggle logic on click
      question.addEventListener("click", () => {
        // Close previous active
        if (previousActiveQuestion && previousActiveQuestion !== question) {
          previousActiveQuestion.classList.remove("active");
          previousActiveQuestion
            .querySelector(".icon-shape")
            .classList.remove("active");
          const prevAnswer = previousActiveQuestion.nextElementSibling;
          prevAnswer.style.maxHeight = "0";
        }

        // Toggle current
        question.classList.toggle("active");
        icon.classList.toggle("active");

        if (question.classList.contains("active")) {
          answer.style.maxHeight = answer.scrollHeight + "px";
          previousActiveQuestion = question;
        } else {
          answer.style.maxHeight = "0";
          previousActiveQuestion = null;
        }
      });

      // Handle pre-opened state via `.open` class (Shopify setting)
      if (question.classList.contains("open")) {
        question.classList.add("active");
        icon.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        previousActiveQuestion = question;
      }

      // ✅ Automatically open the first question by default if none marked `.open`
      if (index === 0 && !section.querySelector(".faq_question.open")) {
        question.classList.add("active");
        icon.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        previousActiveQuestion = question;
      }
    });
  });
});

//Custom page
document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".custom-tabs-section");
  if (!root) return;

  const tabButtons = root.querySelectorAll(".tab-btn");
  const tabContents = root.querySelectorAll(".tab-content");

  // Get all sections on the page that should be controlled by tabs
  const pageSections = document.querySelectorAll("[data-tab-section]");

  // Helper to update URL with tab parameter
  const updateUrl = (tabId) => {
    const url = new URL(window.location);
    url.searchParams.set("tab", tabId);
    window.history.replaceState({}, "", url);
  };

  // Helper to get tab from URL
  const getTabFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("tab");
  };

  // Helper to apply active tab state and control page sections
  const activateTab = (tabId) => {
    // Update tab buttons active state
    tabButtons.forEach((btn) => {
      const span = btn.querySelector("span");
      const isActive = btn.getAttribute("data-tab") === tabId;
      btn.classList.toggle("active", isActive);
      if (span) span.classList.toggle("opacity-100", isActive);
    });

    // Update tab contents within the tabs component
    tabContents.forEach((content) => {
      const isMatch = content.id === tabId;
      content.classList.toggle("hidden", !isMatch);
      content.classList.toggle("active", isMatch);
    });

    // Update page sections visibility based on tab ID
    pageSections.forEach((section) => {
      const sectionTabId = section.getAttribute("data-tab-section");
      const shouldShow = sectionTabId === tabId;

      section.classList.toggle("hidden", !shouldShow);
      section.classList.toggle("active", shouldShow);

      // Update aria attributes for accessibility
      section.setAttribute("aria-hidden", (!shouldShow).toString());
    });

    // Update URL
    updateUrl(tabId);
  };

  // Initialize - check URL first, then default to first tab
  const initializeTabs = () => {
    const urlTab = getTabFromUrl();

    if (urlTab) {
      // Check if URL tab exists in our tabs
      const matchingTab = Array.from(tabButtons).find(
        (btn) => btn.getAttribute("data-tab") === urlTab,
      );
      if (matchingTab) {
        activateTab(urlTab);
        return;
      }
    }

    // Fallback to first tab
    const firstTabButton = tabButtons[0];
    if (firstTabButton) {
      const firstTabId = firstTabButton.getAttribute("data-tab");
      activateTab(firstTabId);
    }
  };

  // Wire click events
  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const tabId = button.getAttribute("data-tab");
      const url = new URL(window.location);

      url.searchParams.set("tab", tabId);

      // Full reload so Jotform + JS heights recalc properly
      window.location.href = url.toString();
    });
  });

  // Initialize tabs
  initializeTabs();

  window.addEventListener("popstate", () => {
    const urlTab = getTabFromUrl();
    if (urlTab) {
      activateTab(urlTab);
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const megaMenus = document.querySelectorAll("details.mega-menu");

  megaMenus.forEach((details) => {
    const activeLink = details.querySelector("a.header__active-menu-item");

    if (activeLink) {
      const summary = details.querySelector("summary");
      if (summary) {
        summary.classList.add("header__active-menu-item");
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // Equalizer without breakpoint (applies always)
  const equalizeAlways = (selector) => {
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    elements.forEach((el) => (el.style.height = "auto"));

    const maxHeight = Math.max(...[...elements].map((el) => el.offsetHeight));

    elements.forEach((el) => {
      el.style.height = `${maxHeight}px`;
    });
  };

  // Equalizer with 990px breakpoint
  const equalizeDesktopOnly = (selector, minWidth = 990) => {
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    // Always reset
    elements.forEach((el) => (el.style.height = "auto"));

    if (window.innerWidth < minWidth) return;

    const maxHeight = Math.max(...[...elements].map((el) => el.offsetHeight));

    elements.forEach((el) => {
      el.style.height = `${maxHeight}px`;
    });
  };

  const runEqualizers = () => {
    // Applies on all screen sizes
    equalizeAlways(
      ".card-wrapper .card-wrapper-home-shop-below .card__caption",
    );

    // Applies only on ≥ 990px
    equalizeDesktopOnly(".how-it-works__step-heading", 990);
  };

  runEqualizers();
  window.addEventListener("resize", runEqualizers);
});

document.addEventListener("click", function (e) {
  const plusBtn = e.target.closest('button[name="plus"]');
  if (!plusBtn) return;

  const input = plusBtn
    .closest("quantity-input")
    ?.querySelector(".quantity__input");
  if (!input) return;

  const max = 99;
  const current = parseInt(input.value, 10) || 0;

  if (current >= max) {
    e.preventDefault();
    input.value = max;
  }
});

document.addEventListener("input", function (e) {
  if (!e.target.classList.contains("quantity__input")) return;

  const max = 99;
  if (parseInt(e.target.value, 10) > max) {
    e.target.value = max;
  }
});

document.addEventListener("DOMContentLoaded", () => {
  function initProductCards() {
    const productCards = document.querySelectorAll("st-product-card");

    productCards.forEach((card) => {
      if (card.querySelector(".st-product-card-sku")) return;

      const handle = card.getAttribute("data-handle");
      const variantId = card.getAttribute("data-variant-id");
      const titleLink = card.querySelector(".st-product-card_title a");

      if (!handle || !variantId || !titleLink) return;

      fetch(`/products/${handle}.js`)
        .then((res) => res.json())
        .then((product) => {
          const variant = product.variants.find((v) => v.id == variantId);
          if (!variant) return;

          if (card.querySelector(".st-product-card-sku")) return;

          const wrapper = document.createElement("div");
          wrapper.className = "st-product-card-variant-info";

          // SKU
          if (variant.sku) {
            const skuEl = document.createElement("p");
            skuEl.className = "st-product-card-sku";
            skuEl.textContent = `SKU: ${variant.sku}`;
            wrapper.appendChild(skuEl);
          }

          // Variant Options (Color, Size)
          if (variant.options && product.options) {
            variant.options.forEach((value, index) => {
              const optionName = product.options[index]?.name;
              if (!optionName || !value) return;

              const optionEl = document.createElement("p");
              optionEl.className = "st-product-card-option";
              optionEl.textContent = `${optionName}: ${value}`;

              wrapper.appendChild(optionEl);
            });
          }

          titleLink.insertAdjacentElement("afterend", wrapper);
        })
        .catch(() => { });
    });
  }

  initProductCards();

  const observer = new MutationObserver(initProductCards);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// mobile header element

document.addEventListener("DOMContentLoaded", function () {
  const menuDetails = document.querySelector("#Details-menu-drawer-container");
  const menuSummary = menuDetails?.querySelector("summary");
  const cartDrawer = document.querySelector("cart-drawer");
  const searchDetails = document.querySelector("details.search-flex");

  if (!menuDetails || !cartDrawer || !searchDetails) return;

  let isProgrammaticClose = false;

  /* ================================
     FIXED MOBILE SCROLL DETECTION
  ================================= */

  let touchMoved = false;
  let blockNextClick = false;

  document.addEventListener(
    "touchstart",
    function () {
      touchMoved = false;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchmove",
    function () {
      touchMoved = true;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchend",
    function () {
      if (touchMoved) {
        blockNextClick = true;

        // Block ghost click after scroll
        setTimeout(() => {
          blockNextClick = false;
        }, 350);
      }
    },
    { passive: true }
  );

  function getBoostWrapper() {
    return document.querySelector(".boost-sd__search-bar-wrapper");
  }

  function getBoostCloseBtn() {
    return document.querySelector(
      'button[data-group="close-search-form"]'
    );
  }

  function hideBoost() {
    const w = getBoostWrapper();
    if (w) w.classList.add("boost-sd__g-hide");
  }

  function showBoost() {
    const w = getBoostWrapper();
    if (w) w.classList.remove("boost-sd__g-hide");
  }

  function clickBoostClose() {
    const btn = getBoostCloseBtn();
    if (btn) btn.click();
  }

  document.addEventListener("click", function (e) {
    const wrapper = getBoostWrapper();
    if (!wrapper) return;

    // 🚫 Block click triggered after scroll
    if (blockNextClick) {
      console.log("[Search Debug] Blocked click after scroll");
      return;
    }

    // 🚫 Ignore Boost close button clicks completely
    if (e.target.closest('button[data-group="close-search-form"]')) {
      return;
    }

    if (wrapper.contains(e.target)) {
      if (!searchDetails.hasAttribute("open")) {
        console.log(
          "[Search Debug] Real TAP detected — opening search via boost wrapper tap",
          { target: e.target }
        );
        searchDetails.setAttribute("open", "");
      }
    }
  });

  function isMenuOpen() {
    return menuDetails.hasAttribute("open");
  }

  function isCartOpen() {
    return cartDrawer.classList.contains("active");
  }

  function closeMenu() {
    if (isMenuOpen() && menuSummary) {
      menuSummary.click();
    }
  }

  function closeCart() {
    if (typeof cartDrawer.close === "function") {
      cartDrawer.close();
    } else {
      cartDrawer.classList.remove("active");
    }
  }

  function closeSearch() {
    if (!searchDetails.hasAttribute("open")) return;

    isProgrammaticClose = true;

    searchDetails.removeAttribute("open");
    clickBoostClose();
    hideBoost();

    setTimeout(() => {
      isProgrammaticClose = false;
    }, 50);
  }

  new MutationObserver(() => {
    if (isCartOpen()) {
      closeMenu();
      closeSearch();
    }
  }).observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["class"],
  });

  new MutationObserver(() => {
    if (isMenuOpen()) {
      closeSearch();
      if (isCartOpen()) closeCart();
    }
  }).observe(menuDetails, {
    attributes: true,
    attributeFilter: ["open"],
  });

  searchDetails.addEventListener("toggle", function () {
    if (isProgrammaticClose) return;

    if (searchDetails.hasAttribute("open")) {
      console.log(
        "[Search Debug] SEARCH OPENED via toggle event (native details open)"
      );
      closeMenu();
      if (isCartOpen()) closeCart();
      showBoost();
    } else {
      clickBoostClose();
      hideBoost();
    }
  });

  if (!searchDetails.hasAttribute("open")) {
    hideBoost();
  }
});

